<template>
    <div class="col-md-6 offset-md-3" style="padding:15px">
        <div id=loginDiv>        
            <router-link to="/">
                <img id="logoLoginPage" src="/images/openplan.png" alt="logo Prolendar">
            </router-link>

        <h2>Reset password</h2>

        <form @submit.prevent="onSubmit">
            <div class="form-group">
                <input type="text" v-model="fromEmail" placeholder="Enter your email address" name="fromEmail" class="form-control" />
                <div> 
                    <p v-if="submitted && !fromEmail">Email address is required </p>
                    <p v-if="submitted && this.fromEmail && emailNotValid">Invalid Email</p>
                </div>
            </div>
                
                
            <div class="form-group">
                <button v-bind='submit' style="width: 100%; background-color: rgb(0, 125, 252); margin-top: 5px" class="btn btn-edit" :disabled="loading">Reset Password</button>
                <img v-show="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            </div>
           <div v-if="error" class="alert alert-danger">{{error}}</div>
        </form>

    </div>

    <!-- Icons for mobile app: -->
    <table id="tableForGooglePlay">
        <tr>
            <td style="text-align: center;">
                <a href="https://apps.apple.com/gb/app/prolendar/id1315846400?ign-mpt=uo%3D2" target="_blank">
                        <img style="height: 30px; width:100px; border-radius: 6px;" id="downloadButtons" src="/images/downloadFromAppStore.png" alt="download from Apple Store icon">
                </a>
            </td>
            <td style="width:13px">   </td>
            <td style="text-align: center;">
                <a href="https://play.google.com/store/apps/details?id=com.prolendar.prolendarnew&hl=en" target="_blank">
                        <img style="height: 29px; width:100px; border-radius: 6px;" id="downloadButtons" src="/images/downloadFromGooglePlay.png" alt="download from Google Play icon">
                </a>
            </td>
        </tr>
    </table>

    </div>
</template>

<style scoped>
p{
    font-size:13px;
    text-align: left
}
#tableForGooglePlay{
    margin: auto;
    width: 40%;
    margin-top: 13px;
}

#loginDiv{
    margin: auto;
    width: 330px;
    padding: 20px;
    border-radius: 6px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    background-color: white
}
    #logoLoginPage {
       height: auto;
        width: 70%;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }

h2{
    mtext-align:center; 
    font-size: 20px; 
    color: black; 
    font-style: bolder;    
}

</style>



<script>
import { required } from '@vuelidate/validators';
import { router } from '@/_helpers';
import { authenticationService } from '@/_services';

    export default {
        data() {
            return {
                fromEmail: '',
                submitted: false,
                loading: false,
                error: '',
            }
        },
        computed: {
            emailNotValid: function () {
                if (this.fromEmail.includes('@')) {
                    return false
                } else {
                    return true
                }
            }
        },

        methods: {
            onSubmit() {
                this.submitted = true
                let canSubmit = this.submitted && this.fromEmail && !this.emailNotValid
                if (canSubmit) {
                    // TO WRITE A FUNCTION WHICH SEND EMAIL WITH 'RESET PASSWORD'!!!
                    this.$http.post('/users/resetpassword?email=' + this.fromEmail, {
                        email: this.fromEmail,
                    }).then(() => {
                        this.$router.push('/resetemail')
                        this.fromEmail = ''
                    }, () => {
                        // alert('error')
                        this.submissionFailure()
                        // this.submitted=false
                        //  this.infoError = true
                        //  this.loader = false
                        this.fromEmail = ''
                    })
                }
            },

        }
    }
</script>